import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
// Idee de Nicolas, 03/09 : une pastille bleue sur ce qui vient de changer,
// « comme sur la TESLA quand elle fait une mise a jour ». Le registre vit
// dans Utils/nouveautes.js.
import { PastilleNouveaute } from "../Elements/Nouveaute";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import { useHistory } from "react-router-dom";
import {
  CloudUpload,
  Equalizer,
  History,
  Subject,
  PlayArrowRounded,
  AssignmentTurnedIn,
  Settings,
  TimelineOutlined,
  SendOutlined,
  SupervisorAccount,
} from "@material-ui/icons";
import { sectionMasquee } from "../../Utils/sectionsReservees";

/**
 * Les sections retirees du menu, et pourquoi.
 *
 * Retour du 07/09 : « il faudrait que tu caches les sections file d'attente et
 * Reglages du laboratoire ». Aucune entree ne s'appelle « file d'attente » :
 * la seule qui lui ressemble est « File d'envoi », et c'est l'un des ecrans
 * partis en production le 04/09 sans avoir ete valides, avec « Reglages du
 * laboratoire ». Sa capture du 08/09 montre le menu entier et confirme la
 * lecture : il ne reste aucun doute sur les deux entrees visees.
 *
 * Retour du 08/09 : « donne moi en Admin la possibilite d'associer ces
 * fonctions uniquement a quelques utilisateurs. » Elles ne sont donc plus
 * cachees a tout le monde, mais a tout le monde SAUF a qui on les autorise,
 * depuis « Gestion des utilisateurs ». La regle, ses limites et le fait
 * qu'elle ne soit pas un controle d'acces : voir Utils/sectionsReservees.
 *
 * ON RETIRE DU MENU, ON NE SUPPRIME PAS LA ROUTE : /fileEnvoi et /labSettings
 * restent joignables en tapant l'adresse, pour qu'on puisse continuer a les
 * recetter pendant qu'elles sont invisibles pour les laboratoires.
 */
const estMasquee = (section) => sectionMasquee(section);

const useStyles = makeStyles((theme) => ({
  list: {
    width: 280,
    padding: theme.spacing(2, 0),
  },
  fullList: {
    width: "auto",
  },
  categorieTitle: {
    fontWeight: 700,
    fontSize: 24,
    textAlign: "center",
    color: theme.palette.primary.main,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    letterSpacing: "0.5px",
  },
  listItem: {
    margin: theme.spacing(0.5, 2),
    borderRadius: 12,
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: theme.palette.primary.main + "11",
      transform: "translateX(4px)",
      "& .MuiListItemIcon-root": {
        color: theme.palette.primary.main,
      },
      "& .MuiListItemText-primary": {
        color: theme.palette.primary.main,
        fontWeight: 600,
      },
    },
  },
  listItemIcon: {
    minWidth: 44,
    color: theme.palette.text.secondary,
  },
  listItemText: {
    "& .MuiListItemText-primary": {
      fontSize: "0.95rem",
      fontWeight: 500,
    },
  },
  divider: {
    margin: theme.spacing(2, 2),
  },
}));

export default function TemporaryDrawer({ open, switchMenu }) {
  const classes = useStyles();
  const [state, setState] = React.useState({
    left: false,
  });
  const history = useHistory();

  /**
   * On naviguait par <Redirect push to={redirect} />, dont l'etat restait
   * pose apres coup : quand la page en cours refusait de partir (un dossier
   * en travail au secretariat), `redirect` gardait la meme valeur, et
   * recliquer la MEME entree de menu ne relancait rien — le menu semblait
   * mort. C'est une des lectures du retour de Nicolas du 04/09 sur l'alerte
   * qu'il n'a pas vue. On pousse maintenant directement dans l'historique :
   * chaque clic est une demande neuve, et le garde-fou de la page repond a
   * chaque fois.
   */
  const allerA = (chemin) => {
    history.push(chemin);
    switchMenu(false);
  };

  useEffect(() => {
    console.log(open);
    setState({ ...state, left: open });
  }, [open]);

  const toggleDrawer = (side, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [side]: open });
  };

  const SideList = () => {
    return (
      <div className={classes.list} role="presentation">
        <h3 className={classes.categorieTitle}>Menu</h3>
        <List>
          <ListItem
            button
            className={classes.listItem}
            onClick={() => allerA("/home")}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <InboxIcon />
            </ListItemIcon>
            <ListItemText primary="Accueil" className={classes.listItemText} />
          </ListItem>
          <ListItem
            button
            className={classes.listItem}
            onClick={() => allerA("/roomsMonitoring")}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <Subject />
            </ListItemIcon>
            <ListItemText
              primary="Suivi des salles"
              className={classes.listItemText}
            />
          </ListItem>
          <ListItem
            button
            className={classes.listItem}
            onClick={() => allerA("/lastAppointments")}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <History />
            </ListItemIcon>
            <ListItemText
              primary="Derniers rendez-vous"
              className={classes.listItemText}
            />
          </ListItem>
          {!estMasquee("labSettings") && (
            <ListItem
              button
              className={classes.listItem}
              onClick={() => allerA("/labSettings")}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <Settings />
              </ListItemIcon>
              <PastilleNouveaute section="labSettings" />
              <ListItemText
                primary="Réglages du laboratoire"
                className={classes.listItemText}
              />
            </ListItem>
          )}
          {/* « Dossiers a traiter » n'est plus une entree de menu : la
              verification est desormais greffee DANS « Secretariat (dossiers) »,
              ou elle ne se montre que lorsqu'il y a quelque chose a arbitrer
              (retour du 28/08 : « un ecran en plus me parait lourd »).
              La route /dossiers existe toujours pour un acces direct. */}
          {/*
              « GESTION DES UTILISATEURS » N'AVAIT AUCUN LIEN, NULLE PART.

              L'ecran existe depuis le 08/09 et c'est lui qui coche les
              sections reservees — mais `/usersmanagment` n'etait cite dans
              aucun menu ni aucun bouton : on ne l'atteignait qu'en tapant son
              adresse. Tant que « Reglages du laboratoire » etait ouvert a
              tous, personne ne s'en apercevait. Le refermer le 22/09 rend ce
              chemin indispensable : sans lui, la demande de Nicolas
              (« donne-moi acces a un tableau de bord ou je peux activer les
              user ») n'aurait nulle part ou se poser.

              L'entree est elle-meme reservee : seuls les comptes coches la
              voient. */}
          {!estMasquee("gestionUtilisateurs") && (
            <ListItem
              button
              className={classes.listItem}
              onClick={() => allerA("/usersmanagment")}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <SupervisorAccount />
              </ListItemIcon>
              <ListItemText
                primary="Gestion des utilisateurs"
                className={classes.listItemText}
              />
            </ListItem>
          )}
          {!estMasquee("fileEnvoi") && (
            <ListItem
              button
              className={classes.listItem}
              onClick={() => allerA("/fileEnvoi")}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <SendOutlined />
              </ListItemIcon>
              <ListItemText
                primary="File d'envoi"
                className={classes.listItemText}
              />
            </ListItem>
          )}
          {!estMasquee("indicateurs") && (
            <ListItem
              button
              className={classes.listItem}
              onClick={() => allerA("/indicateurs")}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <TimelineOutlined />
              </ListItemIcon>
              <ListItemText
                primary="Indicateurs"
                className={classes.listItemText}
              />
            </ListItem>
          )}
          {/* La preparation des patients par la secretaire pour la tablette
              (Nicolas, 16/09). Visible de tous, sans case a cocher : la file
              sert a tous les laboratoires. */}
          <ListItem
            button
            className={classes.listItem}
            onClick={() => allerA("/fileModeDirect")}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <AssignmentTurnedIn />
            </ListItemIcon>
            {/* Nicolas, 18/09 : « Retire le mot "File" dans "File Mode
                direct". Mode direct est suffisant. » */}
            <ListItemText
              primary="Mode direct"
              className={classes.listItemText}
            />
          </ListItem>
          <ListItem
            button
            className={classes.listItem}
            onClick={() => allerA("/secretaryBackoffice")}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <AssignmentTurnedIn />
            </ListItemIcon>
            <PastilleNouveaute section="secretaryBackoffice" />
            <ListItemText
              primary="Secrétariat (dossiers)"
              className={classes.listItemText}
            />
          </ListItem>
          <ListItem
            button
            className={classes.listItem}
            onClick={() => allerA("/statistics")}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <Equalizer />
            </ListItemIcon>
            <ListItemText
              primary="Statistiques"
              className={classes.listItemText}
            />
          </ListItem>
          <ListItem
            button
            className={classes.listItem}
            onClick={() => allerA("/uploadVideo")}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <CloudUpload />
            </ListItemIcon>
            <ListItemText
              primary="Upload une vidéo"
              className={classes.listItemText}
            />
          </ListItem>
          <ListItem
            button
            className={classes.listItem}
            onClick={() => allerA("/managementVideo")}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <CloudUpload />
            </ListItemIcon>
            <ListItemText
              primary="Gestion des vidéo"
              className={classes.listItemText}
            />
          </ListItem>
          <ListItem
            button
            className={classes.listItem}
            onClick={() => allerA("/allvideo")}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <PlayArrowRounded />
            </ListItemIcon>
            <ListItemText primary="Vidéos" className={classes.listItemText} />
          </ListItem>
        </List>
        <Divider className={classes.divider} />
      </div>
    );
  };
  return (
    <>
      <Drawer
        open={state.left}
        onClose={() => {
          toggleDrawer("left", false);
          switchMenu(false);
        }}
      >
        <SideList />
      </Drawer>
    </>
  );
}
